<section>
    <h2>Dashboard</h2>
    <app-vca-filter [pageId]="pageId" [userInfos]="userInfos" [modes]="modes" [platformInfos]="platformInfos" (filterDataOutputEvent)="loadDashboardData($event)">
    </app-vca-filter>
    <app-dashboard [userInfos]="userInfos" [data]="data" [platformInfos]="platformInfos"></app-dashboard>
</section>